import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { AuthService } from '../../authentication/service/auth.service';

@Injectable()
export class WorkerService {

  // API Link
  public static _BACKEND_API_LINK = environment.backendapi;
  headers: Headers;
  headersAuth: Headers;
  options: RequestOptions;
  optionsAuth: RequestOptions;
  public accesstoken: any;
  public tokenid: any;
  public self;

  // Constructor Define --- header's Option in constructor
  constructor(public router: Router, private http: Http,  public cognito: CognitoUtil,
    private globalEventsManager: GlobalEventsManager, private authservice: AuthService) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  getAuthenticationOtions() {
    // tslint:disable-next-line:prefer-const
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    if (this.accesstoken.__zone_symbol__value === null || this.accesstoken.__zone_symbol__value === undefined) {
      this.authservice.logout();
      this.globalEventsManager.showNavBarSeller(false);
      this.globalEventsManager.showNavBarWorker(false);
      this.globalEventsManager.showNavBar(false);
      this.router.navigate(['/login']);
      return;
    }
    if (!this.authservice.isValidToken(this.accesstoken.__zone_symbol__value)) {
      this.cognito.refresh();
      this.accesstoken = this.cognito.getAccessToken();
      this.tokenid = this.cognito.getIdToken();
    }

    this.headersAuth = new Headers({ 'Content-Type': 'application/json' });
    this.headersAuth.append('token', this.accesstoken.__zone_symbol__value);
    this.headersAuth.append('kid', this.tokenid.__zone_symbol__value);
    this.optionsAuth = new RequestOptions({ headers: this.headersAuth });
    return this.optionsAuth;

  }

  // get the Profile Details.
  getworkerDetailsByWorker_UserName(worker_username: string): Observable<any> {
    return this.http.get(WorkerService._BACKEND_API_LINK + '/show_worker_information_by_username/' + worker_username,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get All show_agreed_projects by worker Id
  getAllAgreedProjectsByWorker_id(worker_id: number): Observable<any> {
    return this.http.get(WorkerService._BACKEND_API_LINK + '/show_projects_by_worker_id/' + worker_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get All workers with project Lead
  getWorkers_withProjectLead_ByprojectId(project_id: number): Observable<any> {
    return this.http.get(WorkerService._BACKEND_API_LINK + '/show_workers_with_project_lead/' + project_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }
  // Get the time sheets by project Id and range Date
  getshowtimesheetsByProject_and_worker(project_id: number, worker_user_id: number, startdate: string, enddate: string): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(WorkerService._BACKEND_API_LINK + '/show_time_sheets_for_web_for_worker/' + project_id + '/' + worker_user_id + '/' + startdate + '/' + enddate,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Validate token By Post Method
  postValidateToken(token: string) {
    return this.http.post(WorkerService._BACKEND_API_LINK + '/validate_token',
      { token: token }, this.options).map(this.extractRequests).catch(this.handleError);
  }

  // Worker registation
  workerregistration(modal: any) {
    return this.http.post(WorkerService._BACKEND_API_LINK + '/worker_registration',
      modal, this.options).map(this.extractRequests).catch(this.handleError);
  }

  // Call Email Confirmation
  public confirmEmailVerification(username: string, verification_code: string): Observable<any> {
    return this.http.get(WorkerService._BACKEND_API_LINK + '/email_verification/' + username + '/' + verification_code , this.options)
    .map(this.extractRequests)
    .catch(this.handleError);

}

 // get the Profile Details.
 getallNotificationDetails(username: string): Observable<any> {
  return this.http.get(WorkerService._BACKEND_API_LINK + '/show_worker_notification/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
}

  // Remove Seller Profile Pic
  removeWorkerProfilePic(username) {
    return this.http.delete(WorkerService._BACKEND_API_LINK + '/delete_worker_profile_picture/' + username,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }


  /** Response and Errors Receive ************************ Start  */

  // Response split
  private extractRequests(res: Response) {
    if (res['_body']) {
      const data = JSON.parse(res['_body']);
      if (data != null && data.value) { return data.value; }
      // tslint:disable-next-line:one-line
      else { return data; }
    }
  }

  // Error Handler
  private handleError(error: Response | any) {
    // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
    if (error.message === 'No JWT present or has expired') {
      location.reload();
    }

    let errMsg: string;
    if (error instanceof Response) {
      // const body = error.json() || '';
      const err = JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }

  customErrorHandle(error: Response | any, self) {
    if (error.status === 401) {
      self.cognito.getCurrentUser().signOut();
      self.router.navigate(['/login']);
      self.globalEventsManager.showNavBarSeller(false);
      self.globalEventsManager.showNavBarWorker(false);
      self.globalEventsManager.showNavBar(false);
    }
    // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
    if (error.message === 'No JWT present or has expired') {
      location.reload();
    }

    let errMsg: string;
    if (error instanceof Response) {
      // const body = error.json() || '';
      const err = JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }

  /** Response and Errors Receive ************************ END  */
}



// WEBPACK FOOTER //
// ./src/app/worker/service/worker.service.ts